import { createApp } from 'vue'
import App from './App.vue'
import routes from './route/routes.js'
import BootstrapVueNext from 'bootstrap-vue-next'
import VueWriter from "vue-writer";

import "@/assets/css/materialdesignicons.min.css"
import '@/assets/css/boxicons.min.css'

createApp(App)
    .use(BootstrapVueNext)
    .use(routes)
    .use(VueWriter)
    .mount('#app')
